export default (itemKey: string) => {
  return itemKey && itemKey.replace(/[/\\.]/g, '_')
}
